import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./home/components/Navbar";
import Footer from "./home/components/Footer";

export default function NotFound() {
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 pt-20">
        <div className="relative">
          <h1 className="text-8xl md:text-9xl font-black text-gray-100 select-none">
            404
          </h1>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <i className="ri-error-warning-line text-5xl md:text-6xl text-emerald-600 mb-4"></i>
          </div>
        </div>
        
        <div className="mt-8 space-y-4">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
            Page Not Found
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-md">
            The page you're looking for doesn't exist. You'll be redirected to the home page in a moment.
          </p>
          
          <div className="flex items-center justify-center space-x-2 text-sm text-gray-500 mt-6">
            <i className="ri-time-line"></i>
            <span>Redirecting in 3 seconds...</span>
          </div>
          
          <button
            onClick={() => navigate('/')}
            className="mt-6 px-6 py-3 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center space-x-2"
          >
            <i className="ri-home-line"></i>
            <span>Go Home Now</span>
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
